import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent, } from '@mui/material';
import { NavigateNext } from '@mui/icons-material';
import {useDispatch, useSelector} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { obtenerRegistrosPersonalizado, setearDatosAlStore } from 'store/actions/customAction';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import Formulario from 'components/formulario';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';

const DatosDeLMedioEscrito = ({activeStep, numberStep, handleClose, datosDelMedioEscrito}) => {
    const dispatch = useDispatch();
    const {datosGenerales} = useSelector((state) => state);
    const [catalogoTipoDeCirculacionDeMedioEscrito] = useState('catalogoTipoDeCirculacionDeMedioEscrito');
    const [catalogoTipoDeMedioEscrito] = useState('catalogoTipoDeMedioEscrito');
    const [catalogoTipoDeDistribucionDeMedioEscrito] = useState('catalogoTipoDeDistribucionDeMedioEscrito');
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ errorType: 'error', messageType: '', openResponse: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
    const { nombreDelMedioEscrito, distribucion, circulacion, logoDelMedio, descripcionDelMedio, correoElectronico, diasDeAnticipacion, comentarioEspecificaciones, tipoEscrito } = datosDelMedioEscrito;

    useEffect(() => {
        obtenerTiposDeCirculacion();
        obtenerTiposDeMedioEscrito();
        obtenerTipoDeDistribucionDelMedio();
    },[])

    const obtenerTiposDeCirculacion = async () => {
        const copiaDeCampos = Object.assign({}, camposDelFormulario);

        if(datosGenerales.tiposDeCirculacionDelMedio.length > 0) {
            copiaDeCampos.circulacion.list = datosGenerales.tiposDeCirculacionDelMedio?.map( ({id, descripcion}) => ({id , name: descripcion}) );
            return setCamposDelFormulario(copiaDeCampos);
        }

        setcargandoSolicitud(true);
        let respuesta = await dispatch(obtenerRegistrosPersonalizado({
            controller: catalogoTipoDeCirculacionDeMedioEscrito,
            validateIfDataExists: true,
            stateInStore: datosGenerales.tiposDeCirculacionDelMedio,
            dispatchAction: nombreDeAcciones.SETEAR_TIPOS_DE_CIRCULACION_DEL_MEDIO,
        }));

        setcargandoSolicitud(false);

        if(respuesta?.error || respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

        copiaDeCampos.circulacion.list = respuesta?.data?.map( ({id, descripcion}) => ({id , name: descripcion}) )
        setCamposDelFormulario(copiaDeCampos);
    }

    const obtenerTiposDeMedioEscrito = async () => {
        const copiaDeCampos = Object.assign({}, camposDelFormulario);

        if(datosGenerales.tipoDeMedioEscrito.length > 0) {
            copiaDeCampos.tipoEscrito.list = datosGenerales.tipoDeMedioEscrito?.map( ({id, descripcion}) => ({id , name: descripcion}) );
            return setCamposDelFormulario(copiaDeCampos);
        }

        setcargandoSolicitud(true);
        let respuesta = await dispatch(obtenerRegistrosPersonalizado({
            controller: catalogoTipoDeMedioEscrito,
            validateIfDataExists: true,
            stateInStore: datosGenerales.tipoDeMedioEscrito,
            dispatchAction: nombreDeAcciones.SETEAR_TIPO_DE_MEDIOS_ESCRITO,
        }));

        setcargandoSolicitud(false);

        if(respuesta?.error || respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

        copiaDeCampos.tipoEscrito.list = respuesta?.data?.map( ({id, descripcion}) => ({id , name: descripcion}) )
        setCamposDelFormulario(copiaDeCampos);
    }

    const obtenerTipoDeDistribucionDelMedio = async () => {
        const copiaDeCampos = Object.assign({}, camposDelFormulario);

        if(datosGenerales.tipoDeDistribucionDelMedio.length > 0) {
            copiaDeCampos.distribucion.list = datosGenerales.tipoDeDistribucionDelMedio?.map( ({id, descripcion}) => ({id , name: descripcion}) );
            return setCamposDelFormulario(copiaDeCampos);
        }

        setcargandoSolicitud(true);
        let respuesta = await dispatch(obtenerRegistrosPersonalizado({
            controller: catalogoTipoDeDistribucionDeMedioEscrito,
            validateIfDataExists: true,
            stateInStore: datosGenerales.tipoDeDistribucionDelMedio,
            dispatchAction: nombreDeAcciones.SETEAR_TIPO_DE_DISTRIBUCION_DEL_MEDIO,
        }));

        setcargandoSolicitud(false);

        if(respuesta?.error || respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

        copiaDeCampos.distribucion.list = respuesta?.data?.map( ({id, descripcion}) => ({id , name: descripcion}) )
        setCamposDelFormulario(copiaDeCampos);
    }

    const [camposDelFormulario, setCamposDelFormulario] = React.useState({
        tituloDatosDelMedioEscrito:{
            idelement: "tituloDatosDelMedioEscrito", title:'Datos del medio escrito', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloDatosDelMedioEscrito", value: "", isError:false,
        },
        nombreDelMedioEscrito: {
            idelement: "nombreDelMedioEscrito", value: nombreDelMedioEscrito, label: "Nombre del medio escrito *", pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.#_“”()-*_/@]{4,100}$", validators: ['required'], errorMessages:['El campo es requerido, sin espacios al inicio y final'], isError:false, elementType:'texto', name:"nombreDelMedioEscrito", 'disabled': false, width: '25%'
        },
        circulacion: {
            idelement: "circulacion", value: circulacion , label: "Circulacion *", pattern:"^[1-9][0-9]*$", validators: ['required'],
            errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: '25%'
        },
        distribucion: {
            idelement: "distribucion", value: distribucion , label: "Distribucion *", pattern:"^[1-9][0-9]*$", validators: ['required'],
            errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [{id: 1, name: "Gratuita"}, {id: 2, name: "Voceador"}, {id: 3, name: "Suscriptores"}], handler: undefined, width: '25%'
        },
        logoDelMedio:{
            idelement: "logoDelMedio", value: logoDelMedio, label: "LOGO", validators: {required: true,  size: "8 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"logoDelMedio", fileWidth: true, src: '', multiple: false, accept:".png, .jpg", showInMovil: true, width: '25%', type: "file"
        },
        descripcionDelMedio:{
            idelement: "descripcionDelMedio", value: descripcionDelMedio, label: `Descripción del medio escrito`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,2000}$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "descripcionDelMedio", width: '100%'
        },
        tituloEspecificaciones:{
            idelement: "tituloEspecificaciones", title:'Especificaciones Técnicas', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloEspecificaciones", value: "", isError:false,
        },
        correoElectronico: {
          idelement: "correoElectronico", value: correoElectronico, label: "Correo electrónico para recepción de materiales *", pattern:"^[\\wA-Z0-9._%+-]+@[\\wA-Z0-9.-]+\\.\\w{2,4}$", validators: ['required'], errorMessages:['Ingrese un correo válido'], isError:false, elementType:'texto', name:"correoElectronico", width: "50%"
        },
        diasDeAnticipacion: {
            idelement: "diasDeAnticipacion",  value: diasDeAnticipacion, label: "Días de anticipación para entregar el material a pautar *", pattern:"^[0-9]{1,5}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"diasDeAnticipacion", 'disabled': false, width: "50%"
        },
        comentarioEspecificaciones:{
            idelement: "comentarioEspecificaciones", value: comentarioEspecificaciones, label: `Especificaciones técnicas del material`,pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,2000}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "comentarioEspecificaciones", width: '100%'
        },
        tituloRegistroPrograma:{
            idelement: "tituloRegistroPrograma", title:'Qué tipo de escrito es?', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloRegistroPrograma", value: "", isError:false,
        },
        tipoEscrito: {
            idelement: "tipoEscrito", value: tipoEscrito , label: "Qué tipo de escrito es? * ", pattern:"", validators: ['required'],
            errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [{id: 1, name: "Periodico"}, {id: 2, name: "Revista"}], handler: undefined, width: '25%'
        },
        acciones:{
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const cancelarAccion = () => {
        dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.LIMPIAR_TODO_EL_REDUCER}));
        handleClose();
    };

    const siguientePaso = async (dataForm) => {
        await dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SETEAR_DATOS_DEL_MEDIO_ESCRITO,
            data: {
                datosDelMedioEscrito: dataForm,
                activeStep : activeStep + 1,
                numberStep : numberStep + 1
            }
        }));
    }

    const [buttonList]= React.useState({
        "siguientePaso":{"label":"Siguiente", "icon": <NavigateNext />, "callback":siguientePaso,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <NavigateNext />,"callback":cancelarAccion,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => {
        setDatosDeRespuesta({tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta})
    };

    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>
            <Card>
                <CardContent>
                    <Formulario
                        elements={camposDelFormulario}
                        buttonList={buttonList}
                    />
                </CardContent>
            </Card>
        </Fragment>
    );
}

export default DatosDeLMedioEscrito;